export var GLOBAL_TOP_BAR_HEIGHT = 72;
export var MINI_HEADER_HEIGHT = 56;
export var MAX_PAGE_WIDTH = 1664;
export var NAV_BAR_WIDTH = 72;
export var GUTTER_WIDTH_TOKEN = 4;

/**
 * 🛑 STOP! 🛑
 *
 * You likely don't need to add a constant here.
 *
 * Most constants should be co-located near where they are used.
 *
 * These constants are mostly for layout purposes and refer to mostly global
 * components or components in the parent SPA shell
 */